export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dash',
      icon: 'icon-speedometer'
    },
    
    {
      title: true,
      name: 'Menu'
    },
    {
      name: 'Units',
      icon: 'fa fa-th-list',
      url: '/units/'
    },
    
    {
      name: 'Complexen',
      icon: 'fa fa-th-list',
      url: '/complexen/'
    },
    {
      name: 'Relaties',
      url: '/settings/relaties',
      icon: 'fa fa-users',
      badge: {}
    },
    
    {
      title: true,
      name: 'Administratie',
      url:'/administratie',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Exports',
      url: '/export',
      icon: 'fa fa-file-excel-o',
      badge: {}
    },
    {
      name: 'Templates',
      url: '/templates',
      icon: 'fa fa-files-o',
      badge: {}
    },
    
    {
      name: 'Documenten',
      url: '/documenten/' + new Date().getUTCFullYear().toString(),
      icon: 'fa fa-files-o',
      badge: {}
    },
    {
      name: 'Keuringsrapporten',
      url: '/keuringsrapporten',
      icon: 'fa fa-list-alt',
    },
    {
      name: 'Docparser',
      url: '/docparser/list/new',
      icon: 'fa fa-files-o',
      badge: {}
    },
    {
      name: 'Facturen',
      url: '/facturatie',
      icon: 'fa fa-files-o',
      badge: {}
    },
    {
      name: 'Verkoop',
      url: '/verkoop/openstaand',
      icon: 'fa fa-files-o',
      badge: {},
    },
    {
      name: 'Herinspecties',
      url: '/planning/herinspecties',
      icon: 'fa fa-calendar',
      badge: {},
    },
    {
      name: 'Liftmanagement',
      url: '/management/lopend',
      icon: 'fa fa-calendar',
      badge: {},
    },
    {
      name: 'KPI',
      url: '/kpi',
      icon: 'fa fa-tachometer',
      badge: {},
    },
    {
      title: true,
      name: 'Export',
      redirect: '/export/inventarisatie'
    },
    {
      name: 'Inventarisatie',
      url: '/export/inventarisatie',
      icon: 'fa fa-upload',
      badge: {}
    }
  ]
}
